import { gql } from "@apollo/client";

export const VERIFY_AND_SEND_OTP = gql`
mutation verifyAndSendOtp($data: PhoneInput!){
  verifyAndSendOtp(data: $data){
    isExist
    success
    messages
  }
}
`;

export const PHONE_ENABLE_OTP_VERIFY = gql`
mutation setPhoneForLogin($data: SetPhoneInput!){
  setPhoneForLogin(data: $data){
    success
    messages
  }
}
`;
